import React, { useMemo } from 'react';

const AVATAR_BASE = 'https://ultimatewebscraper.com/assets/images/avatars';
const AVATARS = [
  'avatar1.jpg', 'avatar2.jpg', 'avatar3.jpg', 'avatar4.jpg', 'avatar5.jpg',
  'avatar6.png', 'avatar7.png', 'avatar8.jpg', 'avatar9.jpg', 'avatar10.jpg',
  'avatar11.jpg',
];

const ROLES = [
  'Marketing Manager', 'Growth Lead', 'Data Analyst', 'Product Manager',
  'Founder', 'Operations Manager', 'Sales Director', 'Business Owner',
  'Research Analyst', 'SEO Specialist', 'E-Commerce Manager', 'Freelancer',
];

// Same name-hash avatar mapping used on the landing page
const nameHash = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const getAvatar = (name) => `${AVATAR_BASE}/${AVATARS[nameHash(name) % AVATARS.length]}`;
const getRole = (name) => ROLES[nameHash(name) % ROLES.length];

const ALL_REVIEWS = [
  { author: 'Ken Krause', quote: "By far the best, most complete, flexible, and easiest to use! Don't hesitate!" },
  { author: 'Stefan Hugo', quote: 'Saved me from hours of broken scrapers. 100% would recommend.' },
  { author: 'Ryan Cook', quote: 'Every business owner needs this extension.' },
  { author: 'Nitin Bansal', quote: 'Excellent extension. Works so flawlessly well. Beautiful UI and very well done UX.' },
  { author: 'Georgi Vassilev', quote: 'Exactly what I was looking for, simple to use and very powerful.' },
  { author: 'Rony Dupuy', quote: 'I quickly realized that I was going to use it every day.' },
  { author: 'Chrisjie Grefiel', quote: 'This is truly a game changer. It really helped me a lot.' },
  { author: 'Luis PW', quote: 'Absolutely mindblown by the efficiency and ease of use. The results are amazing.' },
  { author: 'Jeff', quote: 'Works like a charm, PRO is worth it! The best and only scraper I use!' },
  { author: 'Willyam Kartono Suyanto', quote: 'This one is an all in one tool. Great job!' },
  { author: 'Chris Wacker', quote: 'Very fast and good support!' },
  { author: 'Christopher Peters', quote: 'Surprisingly good. Fast, clean interface.' },
];

// Fisher-Yates shuffle and pick first n
const pickRandom = (arr, n) => {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, n);
};

const StarRating = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <svg key={i} className="w-3 h-3 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
);

const TestimonialsStrip = () => {
  const selected = useMemo(() => pickRandom(ALL_REVIEWS, 3), []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
      {selected.map(({ quote, author }) => (
        <div
          key={author}
          className="relative rounded-xl border border-gray-200 dark:border-gray-700/30 bg-gradient-to-br from-gray-50 dark:from-gray-900/60 to-gray-100 dark:to-gray-800/40 px-6 py-5"
        >
          {/* Decorative quote mark */}
          <span className="absolute top-3 right-4 text-4xl font-serif text-gray-200 dark:text-gray-700/50 leading-none select-none">&ldquo;</span>

          <StarRating />
          <p className="text-sm text-gray-600 dark:text-gray-300 mt-3 leading-relaxed italic relative">
            &ldquo;{quote}&rdquo;
          </p>
          <div className="flex items-center gap-2.5 mt-3.5">
            <img
              src={getAvatar(author)}
              alt={author}
              className="w-7 h-7 rounded-full object-cover bg-gray-200 dark:bg-gray-700 ring-1 ring-gray-200 dark:ring-gray-700"
            />
            <div>
              <p className="text-xs text-gray-700 dark:text-gray-300 font-semibold leading-tight">
                {author}
              </p>
              <p className="text-[10px] text-gray-400 dark:text-gray-500 leading-tight">
                {getRole(author)}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TestimonialsStrip;
